module.exports = __webpack_public_path__ + "static/media/banesco-star-icon.430d5212.svg";